import type { HelpFile } from '../../types/help'
import { DatabaseConfigCardTestIds } from '../../../testids/DatabaseConfigCardTestIds'

export const databaseConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/outbound',
  texts: {
    [DatabaseConfigCardTestIds.databaseConfigCard]:
      'Database connection settings for this outbound connector — driver type, host, credentials, and pool size.',
    [DatabaseConfigCardTestIds.cardTitleDatabaseConfig]: null,
    [DatabaseConfigCardTestIds.btnCreateDatabaseConfig]: null,
    [DatabaseConfigCardTestIds.btnEditDatabaseConfig]: null,
    [DatabaseConfigCardTestIds.selectDatabaseType]:
      'Database engine — Postgres, Oracle, MS SQL, etc.',
  },
}
